import LegalLayout from "@/components/LegalLayout";
import { BUSINESS } from "@/lib/business";

export default function AvisoLegal() {
    return (
        <LegalLayout
            testId="aviso-legal-page"
            title="Aviso Legal"
            intro="En cumplimiento de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSICE), se informa a los usuarios de los siguientes datos identificativos del titular de este sitio web."
        >
            <h2>1. Datos identificativos del titular</h2>
            <ul>
                <li><strong>Denominación social:</strong> {BUSINESS.name}</li>
                <li><strong>CIF:</strong> {BUSINESS.cif}</li>
                <li><strong>Domicilio social:</strong> {BUSINESS.address}, {BUSINESS.postalCode} {BUSINESS.city}, {BUSINESS.province}, {BUSINESS.country}</li>
                <li><strong>Teléfono:</strong> {BUSINESS.phone}</li>
                <li><strong>Correo electrónico:</strong> {BUSINESS.email}</li>
            </ul>

            <h2>2. Objeto</h2>
            <p>
                El presente Aviso Legal regula el uso del sitio web titularidad de {BUSINESS.name}. La navegación por el sitio atribuye la condición de usuario e implica la aceptación plena y sin reservas de todas las disposiciones incluidas en este Aviso Legal en la versión publicada en el momento del acceso.
            </p>

            <h2>3. Condiciones de uso</h2>
            <p>
                El usuario se compromete a hacer un uso adecuado de los contenidos y servicios del sitio web y a no emplearlos para incurrir en actividades ilícitas o contrarias a la buena fe y al ordenamiento legal, difundir contenidos o propaganda de carácter racista, xenófobo o contra los derechos humanos, provocar daños en los sistemas físicos y lógicos del titular o de terceros, o introducir virus informáticos.
            </p>

            <h2>4. Propiedad intelectual e industrial</h2>
            <p>
                Todos los contenidos del sitio web, incluyendo a título enunciativo textos, fotografías, gráficos, imágenes, iconos, tecnología, software, enlaces y demás contenidos audiovisuales o sonoros, así como su diseño gráfico y códigos fuente, son propiedad intelectual de {BUSINESS.name} o de terceros, sin que puedan entenderse cedidos al usuario ninguno de los derechos de explotación reconocidos por la normativa vigente.
            </p>
            <p>
                Las marcas, nombres comerciales o signos distintivos son titularidad de {BUSINESS.name} o de terceros, sin que pueda entenderse que el acceso al sitio web atribuya derecho alguno sobre ellos.
            </p>

            <h2>5. Exclusión de garantías y responsabilidad</h2>
            <p>
                {BUSINESS.name} no se hace responsable, en ningún caso, de los daños y perjuicios de cualquier naturaleza que pudieran ocasionar, a título enunciativo: errores u omisiones en los contenidos, falta de disponibilidad del sitio web o la transmisión de virus o programas maliciosos en los contenidos, a pesar de haber adoptado las medidas tecnológicas necesarias para evitarlo.
            </p>

            <h2>6. Enlaces a terceros</h2>
            <p>
                En el caso de que en el sitio web se dispusiesen enlaces o hipervínculos hacia otros sitios de Internet, {BUSINESS.name} no ejercerá ningún tipo de control sobre dichos sitios y contenidos. En ningún caso asumirá responsabilidad alguna por los contenidos de enlaces pertenecientes a sitios web ajenos.
            </p>

            <h2>7. Modificaciones</h2>
            <p>
                {BUSINESS.name} se reserva el derecho de efectuar, sin previo aviso, las modificaciones que considere oportunas en su sitio web, pudiendo cambiar, suprimir o añadir tanto los contenidos y servicios que se presten a través de la misma como la forma en la que éstos aparezcan presentados o localizados.
            </p>

            <h2>8. Legislación aplicable y jurisdicción</h2>
            <p>
                La relación entre {BUSINESS.name} y el usuario se regirá por la normativa española vigente y cualquier controversia se someterá a los Juzgados y Tribunales de Navarra, España.
            </p>

            <p className="mt-10 text-sm text-brand-ink/60">Última actualización: {new Date().toLocaleDateString("es-ES", { year: "numeric", month: "long" })}.</p>
        </LegalLayout>
    );
}
